import { Controller } from "@hotwired/stimulus"

// POS calculator for quick price calculations and totals
// Connects to data-controller="pos-calculator"
export default class extends Controller {
  static targets = ["display", "subtotal", "tax", "total", "items"]
  static values = {
    taxRate: { type: Number, default: 0 },
    currency: { type: String, default: "USD" }
  }

  connect() {
    this.currentInput = "0"
    this.cart = []
    this.updateDisplay()
  }

  press(e) {
    const key = e.params.key || e.currentTarget.dataset.posCalculatorKeyParam
    if (key === undefined) return

    if (key === "C") {
      this.clear()
    } else if (key === "CE") {
      this.clearEntry()
    } else if (key === "BS") {
      this.backspace()
    } else if (key === ".") {
      if (!this.currentInput.includes(".")) {
        this.currentInput += "."
      }
    } else if (key === "+" || key === "-" || key === "*" || key === "/") {
      this.pendingOp = key
      this.previousInput = this.currentInput
      this.currentInput = "0"
    } else if (key === "=") {
      this.calculate()
    } else {
      if (this.currentInput === "0") {
        this.currentInput = key
      } else {
        this.currentInput += key
      }
    }

    this.updateDisplay()
  }

  clear() {
    this.currentInput = "0"
    this.previousInput = null
    this.pendingOp = null
    this.updateDisplay()
  }

  clearEntry() {
    this.currentInput = "0"
    this.updateDisplay()
  }

  backspace() {
    this.currentInput = this.currentInput.slice(0, -1) || "0"
    this.updateDisplay()
  }

  calculate() {
    if (!this.pendingOp || !this.previousInput) return

    const a = parseFloat(this.previousInput)
    const b = parseFloat(this.currentInput)
    let result = 0

    switch (this.pendingOp) {
      case "+": result = a + b; break
      case "-": result = a - b; break
      case "*": result = a * b; break
      case "/": result = b !== 0 ? a / b : 0; break
    }

    this.currentInput = result.toFixed(2)
    this.pendingOp = null
    this.previousInput = null
    this.updateDisplay()
  }

  addToCart(e) {
    const name = e.params.name || "Item"
    const price = parseFloat(this.currentInput) || 0

    if (price <= 0) return

    this.cart.push({ name, price, qty: 1 })
    this.currentInput = "0"
    this.updateCartDisplay()
    this.updateDisplay()
  }

  updateDisplay() {
    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = this.formatCurrency(parseFloat(this.currentInput) || 0)
    }
  }

  updateCartDisplay() {
    const subtotal = this.cart.reduce((sum, item) => sum + (item.price * item.qty), 0)
    const tax = subtotal * (this.taxRateValue / 100)
    const total = subtotal + tax

    if (this.hasSubtotalTarget) this.subtotalTarget.textContent = this.formatCurrency(subtotal)
    if (this.hasTaxTarget) this.taxTarget.textContent = this.formatCurrency(tax)
    if (this.hasTotalTarget) this.totalTarget.textContent = this.formatCurrency(total)

    if (this.hasItemsTarget) {
      this.itemsTarget.innerHTML = this.cart.map((item, i) =>
        `<div class="flex justify-between text-sm py-1">
          <span>${item.name} x${item.qty}</span>
          <span>${this.formatCurrency(item.price * item.qty)}</span>
        </div>`
      ).join("")
    }
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: this.currencyValue
    }).format(amount)
  }

  clearCart() {
    this.cart = []
    this.updateCartDisplay()
  }
}
